import type { AutoShipChurnPreventionOfferModule } from '../../../types/definitions/vendor/graphql-schema.d';

export const getAutoShipChurnPreventionOfferMock = () => ({
  data: {
    client: {
      autoShipChurnPreventionOfferModule: {
        offerId: '10_off_2_and_wsf',
        name: 'AUTO_SHIP_CHURN_PREVENTION_OFFER_MODULE',
        productTrackingEventName: 'autoship_cancellation_intervention_promo',
        declineProductTrackingEventName:
          'decline_autoship_cancellation_promo_offer_button',
        declineProductTrackingEventActionName:
          'decline_autoship_cancellation_promo_offer',
        acceptProductTrackingEventName:
          'accept_autoship_cancellation_promo_offer_button',
        acceptProductTrackingEventActionName:
          'accept_autoship_cancellation_promo_offer',
        headline: 'Get a waived styling fee and 10% off your next 2 Fixes',
        description:
          'Don’t miss out on personalized style, straight to your door.',
        acceptCtaLabel: 'Accept offer',
        declineCtaLabel: 'No, I still want to cancel',
      } as AutoShipChurnPreventionOfferModule,
    },
  },
});
